<template>
    <a href="#" class="text-primary item-link" @click.prevent="open">
        <p class="mb-0">{{ rowData.name }}</p>
        <small v-if="rowData.upc" class="d-block text-muted">#{{ rowData.upc }}</small>
    </a>
</template>

<script>
export default {
    name: 'app-stock-item-name',
    props: ['rowData', 'tableId', 'value', 'index', 'data', 'extraval'],
    methods: {
        open() {
            // bubble up to the Stock page via the global event bus
            this.$hub.$emit('open-stock-detail', this.rowData.id);
        },
    },
};
</script>
